import {
  GET_RECORD_HISTORIES, GET_RECORD_HISTORIES_SUCCESS, GET_RECORD_HISTORIES_FAILURE,
  CREATE_RECORD_HISTORY, CREATE_RECORD_HISTORY_SUCCESS, CREATE_RECORD_HISTORY_FAILURE,
  DELETE_RECORD_HISTORY, DELETE_RECORD_HISTORY_SUCCESS, DELETE_RECORD_HISTORY_FAILURE
} from './mutation-types'
import constant from '../constant'

//
// 指導履歴・面談履歴（F-NEW-03）
//
// 上書きせず追記していくため、一覧・追加・削除のみを扱う。
//
export default {
  state: {
    recordHistories: null,
    recordHistoryNotify: null,
    recordHistoryForbidden: false
  },
  getters: {
    recordHistories: state => {
      return state.recordHistories
    },
    recordHistoryNotify: state => {
      return state.recordHistoryNotify
    },
    recordHistoryForbidden: state => {
      return state.recordHistoryForbidden
    }
  },
  actions: {
    [GET_RECORD_HISTORIES] ({dispatch, state, commit}, params) {
      state.recordHistoryForbidden = false
      return dispatch('apiGet', {url: '/master/users/' + params.userId + '/record_histories', data: params.data || {}})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_RECORD_HISTORIES_FAILURE, res.data)
          } else {
            commit(GET_RECORD_HISTORIES_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          state.recordHistoryForbidden = true
        }
        console.log('GET_RECORD_HISTORIES error', error)
        commit(GET_RECORD_HISTORIES_FAILURE, {})
        if (params.callback) params.callback()
      })
    },
    [CREATE_RECORD_HISTORY] ({dispatch, state, commit}, params) {
      return dispatch('apiPost', {url: '/master/users/' + params.userId + '/record_histories', data: params.data, isLoading: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(CREATE_RECORD_HISTORY_FAILURE, res.data)
          } else {
            commit(CREATE_RECORD_HISTORY_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        var message = (error.response && error.response.status === 403)
          ? 'この操作を行う権限がありません。' : '登録に失敗しました。'
        commit(CREATE_RECORD_HISTORY_FAILURE, {error: message})
      })
    },
    [DELETE_RECORD_HISTORY] ({dispatch, state, commit}, params) {
      return dispatch('apiDelete', {url: '/master/user_record_histories/' + params.id, data: {}})
      .then(res => {
        if (res.data && res.data.error) {
          commit(DELETE_RECORD_HISTORY_FAILURE, res.data)
        } else {
          commit(DELETE_RECORD_HISTORY_SUCCESS, {data: res.data, callback: params.callback})
        }
      })
      .catch(error => {
        var message = (error.response && error.response.status === 403)
          ? 'この操作を行う権限がありません。' : '削除に失敗しました。'
        commit(DELETE_RECORD_HISTORY_FAILURE, {error: message})
      })
    }
  },
  mutations: {
    [GET_RECORD_HISTORIES_FAILURE] (state, data) {
      console.log('GET_RECORD_HISTORIES_FAILURE')
      state.recordHistories = []
    },
    [GET_RECORD_HISTORIES_SUCCESS] (state, data) {
      console.log('GET_RECORD_HISTORIES_SUCCESS')
      state.recordHistories = data.data.data
      if (data.callback) {
        data.callback()
      }
    },
    [CREATE_RECORD_HISTORY_FAILURE] (state, data) {
      console.log('CREATE_RECORD_HISTORY_FAILURE')
      state.recordHistoryNotify = {message: data.error, danger: true}
      setTimeout(() => {
        state.recordHistoryNotify = null
      }, constant.notifyShowTime.long)
    },
    [CREATE_RECORD_HISTORY_SUCCESS] (state, data) {
      console.log('CREATE_RECORD_HISTORY_SUCCESS')
      state.recordHistoryNotify = {message: '履歴を登録しました。', danger: false}
      setTimeout(() => {
        state.recordHistoryNotify = null
      }, constant.notifyShowTime.normal)
      if (data.callback) {
        data.callback()
      }
    },
    [DELETE_RECORD_HISTORY_FAILURE] (state, data) {
      console.log('DELETE_RECORD_HISTORY_FAILURE')
      state.recordHistoryNotify = {message: data.error, danger: true}
      setTimeout(() => {
        state.recordHistoryNotify = null
      }, constant.notifyShowTime.long)
    },
    [DELETE_RECORD_HISTORY_SUCCESS] (state, data) {
      console.log('DELETE_RECORD_HISTORY_SUCCESS')
      state.recordHistoryNotify = {message: '履歴を削除しました。', danger: false}
      setTimeout(() => {
        state.recordHistoryNotify = null
      }, constant.notifyShowTime.normal)
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/record-history.js